import * as types from '../../action-types';

export default (paymentMethod, payload) => ({
  type: types.OVERWRITE_BILLING_ADDRESS_BY_PAYMENT_METHOD,
  paymentMethod,
  payload,
});
